import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { confirmPhoneNumber, signUp } from "api/signup";

const initialState = {
  phoneNumber: "010-",
  password: "",
  passwordConfirm: "",
  name: "",
  birthYear: "",
  sex: "M",
  useTermYN: "N",
  privacyYN: "N",
  marketingYN: "N",
};

export const fetchConfirmPhoneNumber = createAsyncThunk(
  "signup/fetchConfirmPhoneNumber",
  async (payload) => {
    return await confirmPhoneNumber(payload);
  },
);
export const fetchSignUp = createAsyncThunk(
  "signup/fetchSignUp",
  async (payload) => {
    return await signUp(payload);
  },
);

const signupSlice = createSlice({
  name: "signup",
  initialState,
  reducers: {
    setPhoneNumber(state, action) {
      state.phoneNumber = action.payload;
    },
    setPassword(state, action) {
      state.password = action.payload;
    },
    setPasswordConfirm(state, action) {
      state.passwordConfirm = action.payload;
    },
    setName(state, action) {
      state.name = action.payload;
    },
    setBirthYear(state, action) {
      state.birthYear = action.payload;
    },
    setSex(state, action) {
      state.sex = action.payload;
    },
    setUseTermYN(state, action) {
      state.useTermYN = action.payload;
    },
    setPrivacyYN(state, action) {
      state.privacyYN = action.payload;
    },
    setMarketingYN(state, action) {
      state.marketingYN = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchConfirmPhoneNumber.pending, (state, action) => {
      state.phoneNumber = action.meta.arg;
    });
  },
});

export const {
  setPhoneNumber,
  setPassword,
  setPasswordConfirm,
  setName,
  setBirthYear,
  setSex,
  setUseTermYN,
  setPrivacyYN,
  setMarketingYN,
} = signupSlice.actions;

export default signupSlice.reducer;
